export default [
  {
    path: '/quizset',
    component: () => import('@/views/Quizset.vue'),
    name: 'quizset',
    meta: {
      navName: 'quizset',
      sideNav: true,
      requiresAuth: true
    },
  },

  {
    path: '/quizset/new',
    component: () => import('@/views/Quizset/New.vue'),
    name: 'quizset-new',
    meta: {
      navName: 'quizset',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/quizset/:id',
    component: () => import('@/views/Quizset/Edit.vue'),
    name: 'quizset-edit',
    meta: {
      navName: 'quizset',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/quizset/:id/quiz',
    component: () => import('@/views/Quiz.vue'),
    name: 'quizset-quiz',
    meta: {
      navName: 'quizset',
      sideNav: true,
      requiresAuth: true
    }
  },

  {
    path: '/quizset/:quizsetId/quiz/:id',
    component: () => import('@/views/Quiz/Edit.vue'),
    name: 'quizset-quiz-edit',
    meta: {
      navName: 'quizset',
      sideNav: true,
      requiresAuth: true
    }
  }
]
